module.exports = __webpack_public_path__ + "static/media/btcz_paper_front_sm.eafa46a4.png";


//////////////////
// WEBPACK FOOTER
// ./src/btcz_paper_front_sm.png
// module id = ./src/btcz_paper_front_sm.png
// module chunks = 0